import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import LPButton from '@/views/public/landingpage/components/LPButton.vue';
import { useMediaQuery } from '@vueuse/core';
import useMultiLineBreaks from '@/mixins/useMultiLineBreaks';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoleSelector',
  props: {
    lineBreakRenderMode: { default: 'br-tags' }
  },
  setup(__props: any) {

const props = __props as { lineBreakRenderMode: 'br-tags' | 'break-spans' };



const { t } = useI18n();
const isSmartphone = useMediaQuery('(width < 800px)');

const lineBreak = computed(() => (isSmartphone.value ? 'mobile' : 'desktop'));
const linebreaks = t('role-selector.linebreaks') as unknown as Record<string, string>;
const { tl } = useMultiLineBreaks(linebreaks, lineBreak);
const renderResponsiveText = (text: string, useBr = false) => (props.lineBreakRenderMode === 'break-spans'
  ? tl(text, { mode: 'break-spans' })
  : tl(text, useBr));


return { __sfc: true,props, t, isSmartphone, lineBreak, linebreaks, tl, renderResponsiveText, BCXMarkdown, LPButton }
}

})